// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Gglh","top":"styles_top__Tlnj7"};